import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';
import Image from 'apps/new-web/views/components/image';

const TrainerStuff = ({ trainer }) => (<React.Fragment>
  <h3 className="heading-default">{ trainer.firstName } { trainer.lastName }</h3>
  <p><I18n desc="The trainer's role within iFIT." args={{ ifit: 'iFIT' }}>[ifit] Trainer</I18n></p>
</React.Fragment>);

TrainerStuff.propTypes = {
  trainer: PropTypes.object.isRequired
};

const TrainerInfo = ({ trainer }) => (
  <div className="trainer-info">
    { trainer.profileImageThumbnailUrl
      ? <figure>
        <img
          src={ trainer.profileImageThumbnailUrl }
          alt=""
        />
        <figcaption>
          <TrainerStuff trainer={ trainer } />
        </figcaption>
      </figure>
      : <Image
        src="img/ifit-logo-square.svg"
        alt="iFIT"
      />
    }
    { !trainer.profileImageThumbnailUrl &&
      <section className="trainer-name">
        <TrainerStuff trainer={ trainer } />
      </section>
    }
  </div>
);

TrainerInfo.propTypes = {
  trainer: PropTypes.object.isRequired
};

export default TrainerInfo;
